export default async function getFileFromUrl(url: string): Promise<File | null> {
  try {
    const response: Response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob: Blob = await response.blob();
    const contentType: string = response.headers.get('content-type') || 'application/octet-stream';
    const fileName: string = url.split('/').pop() || 'downloaded_file';

    return new File([blob], fileName, { type: contentType });
  } catch (error) {
    console.error('Error fetching the file:', error);
    return null;
  }
}
